import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  FormControl,
  Checkbox,
  ListItemText,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
} from "@mui/material";
import { fetchLabels } from "../../../redux/labelSlice";
import LabelPage from "./LabelPage";
import { fetchDropdownOptions } from "../../../redux/dropdownoptionsSlice";
import { logger } from "../../../utils/logger";

const LabelFilterForm = () => {
  const [status, setStatus] = useState("");
  const [sort, setSort] = useState("");
  const [prasadFilter, setPrasadFilter] = useState([]);
  const [labelAddress, setLabelAddress] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { data = {} } = useSelector((state) => state.dropdownOptions);
  const { user, role } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!data.status.length) {
      dispatch(fetchDropdownOptions("status"));
    }
  }, [dispatch, data.status.length]);

  const handleFilter = async () => {
    try {
      setLoading(true);
      setLabelAddress([]);
      setFilterApplied(false);
      const response = await dispatch(fetchLabels({ status, sort, prasadFilter }));
      if (response && response.payload) {
        if (Array.isArray(response.payload?.data)) {
          setLabelAddress(response.payload?.data);
          logger.info("Filter applied successfully", {
            filter: status,
            user,
            role,
            resultCount: response.payload?.data.length,
          });
        } else {
          setLabelAddress([]);
          setFilterApplied(true);
          logger.warn("Filter applied but no data found", {
            filter: status,
            user,
            role,
          });
        }
      } else {
        setLabelAddress([]);
        setFilterApplied(true);
        logger.error("Filter failed (no response payload)", {
          filter: status,
          user,
          role,
        });
      }
    } catch (err) {
      console.error("Error during filter:", err);
      setLabelAddress([]);
      setFilterApplied(true);
      logger.error("Error while applying filter", {
        filter: status,
        user,
        role,
        error: err.message,
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 2,
          marginBottom: 2,
        }}
      >
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel>Status</InputLabel>
          <Select
            label="Status"
            name="status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            required
          >
            {(data.status || []).map((opt) => (
              <MenuItem key={opt._id} value={opt.value}>
                {opt.value}
              </MenuItem>
            ))}
            <MenuItem value="Prasad-Yes">Prasad-Yes</MenuItem>
            <MenuItem value="">Select</MenuItem>
          </Select>
        </FormControl>
        {status === "Prasad-Yes" && (
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel>Prasad-Yes Filter</InputLabel>
            <Select
              label="Prasad-Yes Filter"
              multiple
              name="prasadFilter"
              value={prasadFilter}
              onChange={(e) => setPrasadFilter(e.target.value)}
              renderValue={(selected) => selected.join(", ")}
            >
              <MenuItem value="Complete">
                <Checkbox checked={prasadFilter.indexOf("Complete") > -1} />
                <ListItemText primary="Complete" />
              </MenuItem>

              <MenuItem value="Alloccasion">
                <Checkbox checked={prasadFilter.indexOf("Alloccasion") > -1} />
                <ListItemText primary="Alloccasion" />
              </MenuItem>

              <MenuItem value="Overseas">
                <Checkbox checked={prasadFilter.indexOf("Overseas") > -1} />
                <ListItemText primary="Overseas" />
              </MenuItem>

              <MenuItem value="Local">
                <Checkbox checked={prasadFilter.indexOf("Local") > -1} />
                <ListItemText primary="Local" />
              </MenuItem>
            </Select>
          </FormControl>
        )}

        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel>Sort </InputLabel>
          <Select
            label="Sort"
            name="sort"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            required
          >
            <MenuItem value="pincode">Pincode</MenuItem>
            <MenuItem value="name">Name</MenuItem>
            <MenuItem value="">Select</MenuItem>
          </Select>
        </FormControl>

        <Button
          variant="contained"
          color="primary"
          sx={{ marginLeft: 1 }}
          onClick={handleFilter}
        >
          Apply Filter
        </Button>
      </Box>

      {loading && (
        <Box textAlign="center" mt={2}>
          <CircularProgress />
        </Box>
      )}

      {!loading && labelAddress.length > 0 ? (
        <LabelPage
          data={labelAddress}
          type={status}
          username={user}
          role={role}
        />
      ) : !loading && filterApplied && labelAddress.length === 0 ? (
        <Box textAlign="center" mt={2} fontWeight="bold" color="black">
          No labels to display
        </Box>
      ) : null}
    </>
  );
};

export default LabelFilterForm;
